export default __webpack_public_path__ + "static/media/laundry1-beforeA-1024w.f3c36db9.avif";